
export default {
  data() {
    return {
      apis:{
         curVersion:'sh/version/pc/current',//获取当前版本
         firstUse:'sh/version/pc/first',//判断用户是否第一次使用当前版本
      },
      userObj:{},//用户对象
      curVersion:{},//当前版本
      versionWnd: false,//当前版本修改内容窗口
    };
  },
  mounted() {
    const me = this;
    me.initUser();
    me.loadCurVersion();
  },
  methods: {
    initUser(){//初始化用户
      const me = this, userStr = sessionStorage.getItem(me.$global.userObj);
      me.userObj = JSON.parse(userStr);
    },
    loadCurVersion(){//获取当前最新版本
        const me = this;
        me.$post({
          url: me.apis.curVersion,
        }).then(rsp => {
          if(!rsp || !rsp.success){
              return;
          }
          me.curVersion = rsp.retObj;
          me.firstUse();
        });
    },
    firstUse(){//判断是不是第一次使用新版本
        const me = this;
        if(!me.userObj || !me.userObj.id || !me.curVersion || !me.curVersion.code){
          return;
        }
        me.$post({
          url: me.apis.firstUse,
          params:{
            userKey: me.userObj.id,
            code: me.curVersion.code
          }
        }).then(rsp => {
           me.versionWnd = rsp && rsp.success && rsp.retObj;
        });
    },
    toVersion(){
      this.versionWnd = false;
       this.$router.push('/version');
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/base/view/version/cmps/icon/src/icon.js